import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { LineChartComponent } from "@/react/components/Analytics/components/LineChartComponent";
import type { ChartDataItem } from "@/react/components/Analytics/components/types";
import { i18nRoot } from "../../constants";
import { viewsColors, viewsSeriesKeys } from "../constants";
import { useVideoAnalyticsViewersTimeline } from "../hooks/useVideoAnalyticsTimeline";

interface ViewersChartProps {
  dateGrouping?: string;
  endDate?: string;
  signedId: string;
  startDate?: string;
}

export const ViewersChart = ({
  signedId,
  startDate,
  endDate,
  dateGrouping,
}: ViewersChartProps) => {
  const { data: timelineData, isLoading } = useVideoAnalyticsViewersTimeline({
    signedId,
    startDate,
    endDate,
    dateGrouping,
  });

  const chartData = useMemo((): ChartDataItem[] => {
    if (!timelineData || timelineData.length === 0) {
      return [];
    }

    return timelineData.map(item => ({
      id: item.date_period,
      label: item.date_period,
      views: item.views,
      unique_viewers: item.unique_viewers,
    }));
  }, [timelineData]);

  return (
    <div className="mb-8">
      <LineChartComponent
        title={t([i18nRoot, "analytics.chart.views_timeline.title"])}
        tooltip={t([i18nRoot, "analytics.chart.views_timeline.tooltip"])}
        data={chartData}
        indexBy="label"
        seriesKeys={viewsSeriesKeys}
        colors={viewsColors}
        rootLocale={[i18nRoot, "analytics.chart.views_timeline.lines"]}
        className="w-full"
        isLoading={isLoading}
      />
    </div>
  );
};
